module.exports = __webpack_public_path__ + "static/media/global-background-m.d4a7a5e8.png";